import React, { memo } from 'react';

import Snapshot from '../../../components/Snapshot';
import Overlay from './Overlay';

const OverlaidSnapshot = memo(({ snapshot, sharedDisplayed, onClick }) => (
  <Snapshot
    snapshot={snapshot}
    selected={snapshot.selected}
    onClick={onClick}
    controls
    imageSrcOverride={sharedDisplayed ? (snapshot.sharedURI || snapshot.smallURI) : undefined}
  >
    <Overlay overlayKey={snapshot.overlay} />
  </Snapshot>
));

export default OverlaidSnapshot;
